import React from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { IProduct } from '../../../../../utils/types/contentful';
import { ShopProductItem } from '../../../../Shop/index';

export interface ProductMainRecommendationsProps {
  product: IProduct;
}

export const ProductMainRecommendations: React.FC<
  ProductMainRecommendationsProps
> = ({ recommendations, label }) => (
  <div className='w-full'>
    <div className='my-3'>
      <Label
        {...label}
        color={{ classname: 'gray-900' }}
        size='xl'
        weight='medium'
      />
    </div>
    <div className='grid grid-cols-2 gap-3'>
      {recommendations.gridItems.map((item) => (
        <div className='my-2 relative'>
          <ShopProductItem
            {...item}
            isMini
          />
        </div>
      ))}
    </div>
  </div>
);
